import React from 'react';
import { FaCheck, FaTimes } from 'react-icons/fa';

interface PasswordStrengthIndicatorProps {
  password: string;
}

const PasswordStrengthIndicator: React.FC<PasswordStrengthIndicatorProps> = ({ password }) => {
  const hasMinLength = password.length >= 8;
  const hasUpperCase = /[A-Z]/.test(password);
  const hasNumber = /[0-9]/.test(password);
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

  const conditions = [
    { label: 'Au moins 8 caractères', met: hasMinLength },
    { label: 'Une majuscule', met: hasUpperCase },
    { label: 'Un chiffre', met: hasNumber },
    { label: 'Un caractère spécial', met: hasSpecialChar },
  ];

  return (
    <div className="mt-3 space-y-2">
      {conditions.map((condition, index) => (
        <div key={index} className="flex items-center gap-2">
          <div className={`w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 ${
            condition.met ? 'bg-green-100' : 'bg-gray-100'
          }`}>
            {condition.met ? (
              <FaCheck className="w-3 h-3 text-green-600" />
            ) : (
              <FaTimes className="w-3 h-3 text-gray-400" />
            )}
          </div>
          <span className={`text-xs ${
            condition.met ? 'text-green-600 font-medium' : 'text-gray-500'
          }`}>
            {condition.label}
          </span>
        </div>
      ))}
    </div>
  );
};

export default PasswordStrengthIndicator;

